import { AP, CongestionLevel, DeviceCount, DeviceDetection } from '@/domain/model'
import { AxiosInstance } from 'axios'

export interface GetAPListReponse {
  aps: AP[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CreateAPResponse {
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PutAPResponse {
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface DeleteAPResponse {
}

export interface CongestionLevelResponse {
  congestionLevel: CongestionLevel;
}

export interface GetDeviceCountLogResponse {
  deviceCounts: DeviceCount[];
}

export interface GetDeviceDetectionsResponse {
  deviceDetections: DeviceDetection[];
}

export default class AdminAPIClient {
  constructor(private client: AxiosInstance) { }

  async createAP(ap: AP): Promise<CreateAPResponse> {
    const params = {
      mac: ap.mac,
      name: ap.name,
      rssi_threshold: ap.rssiThreshold,
      stay_threshold: ap.stayThreshold,
      congestion_border_1: ap.congestionBorder1,
      congestion_border_2: ap.congestionBorder2,
    }
    return this.client.post(`/admin/aps`, params).then(res => {
      console.debug(res)
      return {} as CreateAPResponse
    })
  }

  async updateAP(ap: AP): Promise<PutAPResponse> {
    const params = {
      name: ap.name,
      rssi_threshold: ap.rssiThreshold,
      stay_threshold: ap.stayThreshold,
      congestion_border_1: ap.congestionBorder1,
      congestion_border_2: ap.congestionBorder2,
    }
    return this.client.put(`/admin/aps/${ap.mac}`, params).then(res => {
      console.debug(res)
      return {} as PutAPResponse
    })
  }

  async deleteAP(apmac: string): Promise<DeleteAPResponse> {
    return this.client.delete(`/admin/aps/${apmac}`).then(res => {
      console.debug(res)
      return {} as DeleteAPResponse
    })
  }

  async getAPList(): Promise<GetAPListReponse> {
    return this.client.get(`/admin/aps`).then(res => {
      console.debug(res)
      const aps = res.data.aps.map((ap: any) => {
        return new AP({
          mac: ap.mac,
          name: ap.name,
          rssiThreshold: ap.rssi_threshold,
          stayThreshold: ap.stay_threshold,
          congestionBorder1: ap.congestion_border_1,
          congestionBorder2: ap.congestion_border_2,
        })
      })
      return { aps } as GetAPListReponse
    })
  }

  async getCongestionLevel(apmac: string): Promise<CongestionLevelResponse> {
    return this.client.get(`/admin/aps/${apmac}/congestion_level`).then(res => {
      const cl = res.data;
      const congestionLevel = new CongestionLevel({
        APMAC: cl.ap_mac,
        ts: new Date(cl.ts),
        level: cl.level,
        stayCount: cl.stay_count,
        nonstayCount: cl.nonstay_count,
        border1: cl.border1,
        border2: cl.border2,
      })
      return { congestionLevel } as CongestionLevelResponse
    })
  }

  async getDeviceCountLog(apmac: string, unit: string): Promise<GetDeviceCountLogResponse> {
    return this.client.get(`/admin/aps/${apmac}/device_count_log?unit=${unit}`).then(res => {
      console.debug(res)
      const dcs = res.data.device_counts.map((dc: any) => {
        return new DeviceCount({
          APMAC: dc.ap_mac,
          timestamp: new Date(Date.parse(dc.ts)),
          stayCount: dc.stay_count,
          nonstayCount: dc.nonstay_count,
        })
      })
      return {
        deviceCounts: dcs,
      } as GetDeviceCountLogResponse
    })
  }

  async getDeviceDetections(apmac: string): Promise<GetDeviceDetectionsResponse> {
    return this.client.get(`/admin/aps/${apmac}/device_detections`).then(res => {
      console.debug(res)
      const deviceDetections = res.data.device_detections.map((dd: any) => {
        return new DeviceDetection({
          mac: dd.mac,
          rssi: dd.rssi,
          timestamp: dd.timestamp,
          foundAt: dd.found_at,
          stay: dd.stay,
        });
      })
      return { deviceDetections } as GetDeviceDetectionsResponse
    })
  }
}